import type { ComponentProps } from 'react';
import { Button } from 'tamagui';
import { ACCENT_FOCUS_VISIBLE_STYLE } from '../lib/focus-ring';

type ButtonProps = ComponentProps<typeof Button>;

/**
 * Tamagui `Button` whose keyboard focus ring is the shared Signal-Blue accent.
 * Tamagui's Button ships a built-in `focusVisibleStyle` using the theme's
 * `$outlineColor`; overriding that same pseudo re-points the ring to the accent.
 * Used for the Vehicle Detail header actions, the chat Send control, and the
 * delete-vehicle dialog buttons.
 */
export function FocusRingButton(props: ButtonProps) {
  return <Button focusVisibleStyle={ACCENT_FOCUS_VISIBLE_STYLE} {...props} />;
}
